import React, { Component } from 'react';
import {connect} from 'react-redux';
import {  getSubOptionDataByOptionId, UpdateSubOption, emptyDemographicsSubOption } from '../../actions/demographics';
import EditSubOption from '../../components/demographics/editSubOption';

class EditDemographicsSubOption extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.sub_option_id = this.queryString.split("&sop:")[1]
    }

    this.state={
        sub_option_id : this.sub_option_id
    };
    this.UpdateSubOption = this.UpdateSubOption.bind(this);
    this.emptyDemographicsOption = this.emptyDemographicsOption.bind(this);
  }

 

  componentDidMount(){
    if(this.state.sub_option_id){
       this.props.dispatch( getSubOptionDataByOptionId(this.state.sub_option_id));
    }
  }

  UpdateSubOption( data){
    this.props.dispatch(UpdateSubOption(data));
  }

  emptyDemographicsOption(){
      this.props.dispatch(emptyDemographicsSubOption());
  }
  
  render(){

   
    let showEditDemographicsCategoriesSubOptionView ="";
    if(this.props.showEditSubOption){
         showEditDemographicsCategoriesSubOptionView = <EditSubOption
         showEditSubOption = {this.props.showEditSubOption}
         SubOptionEditData = {this.props.SubOptionEditData}
         UpdateSubOption = {this.UpdateSubOption}
         subOptionUpdateSuccess = {this.props.subOptionUpdateSuccess}
         subOptionUpdateSuccessMessage = {this.props.subOptionUpdateSuccessMessage}
         subOptionUpdateFailMessage = {this.props.subOptionUpdateFailMessage}

         emptyDemographicsOption = {this.emptyDemographicsOption}
        />
    }
    
      
    return (
        <div> 
             {showEditDemographicsCategoriesSubOptionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    showEditSubOption : state.demographics.showEditSubOption,
    SubOptionEditData : state.demographics.SubOptionEditData,
    subOptionUpdateSuccess : state.demographics.subOptionUpdateSuccess,
    subOptionUpdateSuccessMessage : state.demographics.subOptionUpdateSuccessMessage,
    subOptionUpdateFailMessage : state.demographics.subOptionUpdateFailMessage,

  }
}

export default connect(mapStateToProps)(EditDemographicsSubOption);



// WEBPACK FOOTER //
// ./src/pages/demographics/editSubOption.js